import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import confirmationPageActions from '../actions/confirmationPage';
import {MERCHANT_OF_RECORD} from '../utils/constants';

function updateOnboardingStatusToBMXIdentified(store) {
    request.post(`/${config.url_prefix}/api/submitOnboardingMessage`)
        .send({
            onboardingStatus: 'BUSINESS_MODEL_SWITCH_IDENTIFIED',
            additionalFields: {
                billingCurrency: store.getState().userInfoDetails.userInfoMetadata.billingCurrencyCode
            }
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(confirmationPageActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    if (response.statusCode >= 400 || response.code >= 400) {
                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else if (response.statusCode >= 200 && response.statusCode < 300) {
                            request.post(`/${config.url_prefix}/api/submitOnboardingMessage`)
                                .send({
                                    onboardingStatus: 'BUSINESS_MODEL_SUBMITTED',
                                    additionalFields: {
                                        businessModel: MERCHANT_OF_RECORD.EG
                                    }

                                })
                                .set('x-homeaway-site', store.getState().system.siteName)
                                .end((err, res) => {
                                    if (err) {
                                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                                        store.dispatch(actions.enableLoadOverLay(false));
                                    } else if (res.statusCode >= 200 && res.statusCode < 300) {
                                        store.dispatch(actions.changeAppState('PAYOUT_DETAILS'));
                                    } else {
                                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                                        store.dispatch(actions.enableLoadOverLay(false));
                                    }
                                });
                    } else {
                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    }
                } catch (exp) {
                    store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
        });

    return null;
}

export default updateOnboardingStatusToBMXIdentified;
